import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Link,
  Typography,
} from "@mui/material";

import SlidingPanel from "react-sliding-side-panel";
import SelectDropdown from "../../../../../../Supporting files/SelectDropdown/SelectDropdown";
import RKTextField from "../../../../../../Supporting files/RKTextField/RKTextField";
import DatePicker from "../../../../../../Supporting files/DatePicker/DatePicker";
interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
  add_cuurency_status: boolean;
}

const AddCurrency: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
  add_cuurency_status,
}) => {
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const [currencycodes, setCurrencyCodes] = React.useState("");
  const [currencyName, setCurrencyName] = React.useState("");
  // const [currencycode, setCurrencyCode] = React.useState("");
  const [fraction, setFraction] = React.useState("");
  const [format, setFormat] = React.useState("");
  const [fractionUnit, setFractionUnit] = React.useState("");
  const [smallfractionUnit, setSmallFractionUnit] = React.useState("");
  const [decimalPlaces, setDecimalPlaces] = React.useState("");
  // const [addcurrency, setAddCurrency] = React.useState("");
  const [Date, setDate] = React.useState<Date | null>(null);
  const [currencySymbol, setCurrencySymbol] = React.useState("");
  const [exchangeRate, setExchangeRate] = React.useState("");

  const currencycode_data = [
    { key: "Euro", value: "Euro" },
    { key: "Dollor", value: "Dollor" },
    { key: "INR", value: "INR" },
    { key: "Dinar", value: "Dinar" },
    { key: "Dirham", value: "Dirham" },
  ];
  const decimalPlaces_data = [
    { key: "1", value: "1" },
    { key: "2", value: "2" },
    { key: "3", value: "3" },
    { key: "4", value: "4" },
  ];
  const format_data = [
    { key: "1,236,452.58", value: "1,236,452.58" },
    { key: "1,236,452.58", value: "1,236,452.58" },
    { key: "1,236,452.58", value: "1,236,452.58" },
    { key: "1,236,452.58", value: "1,236,452.58" },
  ];
  const exchangeRate_data = [
    { key: "1", value: "1" },
    { key: "2", value: "2" },
    { key: "3", value: "3" },
    { key: "4", value: "4" },
  ];
  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };

  return (
    <div>
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        panelClassName="slidingPanel"
        backdropClicked={() => value_update(attrName, false)}
      >
        <div className="pt-5">
          <Grid container spacing={3} alignItems="center">
            <Grid xs={12}>
              {pageStatus == 1 ? (
                <h4 className="mb-2 mt-0 ml-0 text-left">New Currency</h4>
              ) : pageStatus == 2 ? (
                <h4 className="mb-0 mt-0 ml-0 text-left">
                  Add Exchange Rate - AED
                </h4>
              ) : null}
            </Grid>
          </Grid>
          <div className="scrollable_area">
            {pageStatus === 1 ? (
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Currency Code*"
                        value={currencycodes}
                        attrName={setCurrencyCodes}
                        value_update={updateMasterState}
                        dropdown_data={currencycode_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <RKTextField
                        class_name="inputField"
                        title="Currency Symbol*"
                        value={currencySymbol}
                        value_update={updateMasterState}
                        attrName={setCurrencySymbol}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <RKTextField
                        class_name="inputField"
                        title="Currency Name*"
                        value={currencyName}
                        value_update={updateMasterState}
                        attrName={setCurrencyName}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <RKTextField
                        class_name="inputField"
                        title="Fraction*"
                        value={fraction}
                        value_update={updateMasterState}
                        attrName={setFraction}
                        warn_status={false}
                      />
                      <p className="example">Sub-currency. For e.g. “Cent”</p>
                    </Grid>
                    <Grid xs={12}>
                      <RKTextField
                        class_name="inputField"
                        title="Fraction Unit*"
                        value={fractionUnit}
                        value_update={updateMasterState}
                        attrName={setFractionUnit}
                        warn_status={false}
                      />
                      <p className="example">
                        1 currency = [?] Fraction for e.g. 1 USD = 100 Cent
                      </p>
                    </Grid>
                    <Grid xs={12}>
                      <RKTextField
                        class_name="inputField"
                        title="Smallest Currency Fraction Value"
                        value={smallfractionUnit}
                        value_update={updateMasterState}
                        attrName={setSmallFractionUnit}
                        warn_status={false}
                      />
                      <p className="example">
                        1 currency = [?] Fraction for e.g. 1 USD = 100 Cent
                      </p>
                    </Grid>
                    <Grid xs={12}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Decimal Places*"
                        value={decimalPlaces}
                        attrName={setDecimalPlaces}
                        value_update={updateMasterState}
                        dropdown_data={decimalPlaces_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Format*"
                        value={format}
                        attrName={setFormat}
                        value_update={updateMasterState}
                        dropdown_data={format_data}
                        warn_status={false}
                      />
                    </Grid>
                    {add_cuurency_status === false ? (
                      <Grid xs={12}>
                        <Link
                          underline="none"
                          className="greenBtn addfile ml-0"
                          onClick={() => {
                            //setAddCurrency(true);
                            setPageStatus(pageStatus + 1);
                          }}
                        >
                          Add Currency
                        </Link>
                      </Grid>
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
            ) : null}
            {pageStatus === 2 ? (
              <Grid container spacing={3} style={{ marginTop: "25px" }}>
                <Grid xs={12}>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <DatePicker
                        class_name="inputField"
                        title="Date of Birth"
                        value={Date}
                        attrName={setDate}
                        value_update={updateMasterState}
                        error_message="Please enter Date of Birth"
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Exchange Rate (in INR)"
                        value={exchangeRate}
                        attrName={setExchangeRate}
                        value_update={updateMasterState}
                        dropdown_data={exchangeRate_data}
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : null}
            {pageStatus === 3 ? (
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <Grid xs={12}>
                  <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                  <p className="quote_success text-center">
                    New Currency has been added successfully!
                  </p>
                </Grid>
              </Grid>
            ) : null}
          </div>
          {pageStatus !== 3 ? (
            <Grid container spacing={3}>
              <Grid
                xs={12}
                className="ctaBtn mt-4"
                style={{ textAlign: "center" }}
              >
                <Button
                  variant="contained"
                  className="submitBtn"
                  onClick={() => {
                    pageStatus === 1 ? setPageStatus(3) : setPageStatus(1);
                  }}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </div>
      </SlidingPanel>
    </div>
  );
};

export default AddCurrency;
